module.exports = __webpack_public_path__ + "img/icon-ecosystem-graylight.b8b199b0.svg";